import {orderBy} from 'lodash'
import React from 'react'
import ListBox from '../listbox'
import {Consumer} from '../../context'

export default function SelectGroup(props) {

  const {selectedGroup, onClick} = props

  return (<Consumer>{ context => {

    return (
      <ListBox
        className= "select-group"
        labelId= "group_label"
        items= {[{...selectedGroup, selected: true}]}
        onClick = {onClick}
        />)
  }}</Consumer>)
}
